import { useAuth } from "../contexts/authContext";
import React, { useEffect, useState } from "react";
import { fetchCvReport } from "../service/cv-report.service";
import {Table, Spin, Typography, Tag, Alert, Button, Space} from "antd";
import {ColumnsType} from "antd/es/table";
import {setUserId} from "../config/amplitude/amplitude";
import {useCvBalanceStore} from "../store/useCvBalanceStore";
import { useNavigate } from "react-router-dom";


const { Title } = Typography;

interface CvReport {
    createdAt: string;
    companyName: string;
    vacancyUrl: string;
    vacancyTitle: string;
    platform: string;
    cvUrl: string;
    cvFileName: string;
    isExternalSumition: boolean;
}

const ReportPage = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const {cvSent, sendsInPackage, isEnabled, isLoading, fetchBalance} = useCvBalanceStore();
    const [loading, setLoading] = useState(true);
    const [cvReport, setCvReport] = useState([]);
    const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCursors, setPageCursors] = useState<any[]>([]);
    const [totalDocs, setTotalDocs] = useState(0);
    const pageSize = 20;
    const data = [
        { value: 1000, name: 'CV sent', fill: '#8884d8' },
        { value: 600, name: 'HR interview', fill: '#82ca9d' },
        { value: 300, name: 'Tech interview', fill: '#ffc658' },
        { value: 100, name: 'Offer', fill: '#ff7f50' },
    ];



    const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff7f50'];

    const total = data[0].value; // first step is the base

    const dataWithLabels = data.map(item => ({
        ...item,
        label: `${item.name}: ${item.value} (${Math.round((item.value / total) * 100)}%)`
    }));



    useEffect(() => {
        document.title = 'Report - CV Postman App';
        localStorage.setItem('lastOpenedPage', '/report');
        setUserId(currentUser.email);
        preloadCursors();
        loadReports(1);
    }, [currentUser.email]);


    const preloadCursors = async () => {
        const cursors = [];
        let lastVisible = null;
        let total = 0;

        for (let i = 0; i < 1000; i++) { // maximum 100 pages
            const { snapshot } = await fetchCvReport(currentUser.email, pageSize, lastVisible);
            if (snapshot.empty) break;

            cursors.push(snapshot.docs[0]); // save first doc of this page
            lastVisible = snapshot.docs[snapshot.docs.length - 1];
            total += snapshot.docs.length;

            if (snapshot.docs.length < pageSize) break; // end of collection
        }

        setPageCursors(cursors);
        setTotalDocs(total);
    };

    const loadReports = async (page: number) => {
        setLoading(true);
        const cursor = page > 1 ? pageCursors[page - 1] : null;

        const result = await fetchCvReport(currentUser.email, pageSize, cursor);
        setCvReport(result.data);
        setCurrentPage(page);
        setLoading(false);
    };




    const columns: ColumnsType<CvReport> = [
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            align: "center",
            width: 200,
            render: (text) =>  new Date(text.seconds * 1000).toLocaleString()
        },
        {
            title: "Platform",
            dataIndex: "platform",
            key: "platform",
            align: "center",
            width: 100,
            render: (text, record) => (

                text ? <Tag color={text === "dou" ? "green" : "blue"} style={{ fontSize: 14 }}>
                    {text.toUpperCase()}
                </Tag> : <Tag color="green" style={{ fontSize: 14 }}>
                    DOU
                </Tag>
            ),
        },
        {
            title: "Company",
            dataIndex: "companyName",
            key: "companyName",
            align: "center",
            width: 180,
        },
        {
            title: "Vacancy URL",
            dataIndex: "vacancyUrl",
            key: "vacancyUrl",
            width: 320,
            render: (text, record) => (
                <a href={text} target="_blank" rel="noopener noreferrer">
                    {record.vacancyTitle}
                </a>
            ),
        },

        {
            title: "CV sent",
            dataIndex: "cvUrl",
            key: "cvUrl",
            width: 250,
            render: (text, record) => (
                text !== "-as per djinni setup-" ?
                    <a href={text} target="_blank" rel="noopener noreferrer">
                        {record.cvFileName}
                    </a> : <span>{text}</span>

            ),
        },
        {
            title: "Cover Letter",
            dataIndex: "coverLetterText",
            key: "coverLetterText",
            width: 320,
            render: (text: string, record: CvReport) => {
                const isExpanded = expandedRows[record.createdAt];
                const maxLength = 100;
                const isLong = text?.length > maxLength;

                const toggleExpand = () => {
                    setExpandedRows(prev => ({
                        ...prev,
                        [record.createdAt]: !isExpanded
                    }));
                };

                return (
                    <div style={{ maxWidth: 300 }}>
                        {isExpanded || !isLong ? text : `${text.slice(0, maxLength)}...`}
                        {isLong && (
                            <span
                                onClick={toggleExpand}
                                style={{ color: '#1890ff', cursor: 'pointer', marginLeft: 8 }}
                            >
                        {isExpanded ? ' Show less' : ' Read more'}
                    </span>
                        )}
                    </div>
                );
            }
        }

    ];

    return (
        <div style={{ padding: "20px" }}>
            <Title level={2}>CV Reports: {totalDocs || 0}</Title>

            {(sendsInPackage - cvSent) <= 5 && (sendsInPackage - cvSent) >= 1 &&
                <Space direction="horizontal" size="middle" style={{ marginTop: 16, alignItems: 'center' }}>
                    <Alert
                        message="CV sends will reach the limit soon. Top up the balance to prevent the service from unexpected termination"
                        type="error"
                        style={{ margin: 0 }}

                    />
                    <Button type="primary" onClick={() => navigate('/balance')}>
                        Top Up
                    </Button>
                    <Button type="primary" onClick={() => navigate('/balance')}>
                        Get FREE
                    </Button>
                </Space>
            }
            {!!totalDocs && cvSent >= sendsInPackage &&
            <Space direction="horizontal" size="middle" style={{ marginTop: 16, alignItems: 'center' }}>
                <Alert
                    message="CV sends are out of limit. Please top up your balance to continue service working"
                    type="error"
                    style={{ margin: 0 }}

                />
                <Button type="primary" onClick={() => navigate('/balance')}>
                    Top Up
                </Button>
                <Button type="primary" onClick={() => navigate('/balance')}>
                    Get FREE
                </Button>

            </Space>
            }
            {cvSent > 0 &&
            <Alert style={{marginTop: 16}}
                   message="Automation runs 3 times per day: 10am, 1pm, 4pm, Mon-Fri by Kyiv time zone"
                   type="info"/>
            }
            {loading ? (
                <div style={{ textAlign: "center", padding: "50px 0" }}>
                    <Spin size="large" />
                </div>
            ) : (<>
                    <Table
                        dataSource={cvReport}
                        columns={columns}
                        rowKey={(record) => record.createdAt}
                        bordered
                        pagination={{
                            pageSize,
                            current: currentPage,
                            total: totalDocs,
                            onChange: (page) => loadReports(page),
                        }}
                        loading={loading}
                        locale={{
                            emptyText: (
                                <div style={{color: "#1a7bef", fontWeight: "500"}}>
                                    Report data will appears after automation job is executed. <br/> The automation runs
                                    3 times per day: 10am, 1pm, 4pm, Mon-Fri, during working hours by Kyiv time zone
                                </div>
                            ),
                        }}
                    />


                    {/*<FunnelChart width={400} height={300}>
                        <Tooltip />
                        <Funnel dataKey="value" data={data} isAnimationActive>
                            {
                                data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                ))
                            }
                            <LabelList position="right" fill="#000" stroke="none" dataKey="name" />
                        </Funnel>
                    </FunnelChart>*/}
                </>
            )}
        </div>
    );
};

export default ReportPage;
